import { render, staticRenderFns } from "./VaMediumEditor.demo.vue?vue&type=template&id=2e182331&scoped=true&"
import script from "./VaMediumEditor.demo.vue?vue&type=script&lang=js&"
export * from "./VaMediumEditor.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e182331",
  null
  
)

export default component.exports